import styled from 'styled-components'

export { editorBuilder } from './editorBuilder'
export { default as Fields } from './Fields'

export const Separator = styled.hr`
    border: none;
    border-bottom: 1px solid rgb(221, 222, 225);
    margin: 10px 0;
`

export const Title = styled.h3`
    color: rgb(54, 65, 89);
    font-size: 14px;
    font-weight: 600;
    padding: 0 10px 15px;
`
